import styled, { css } from 'styled-components'

type ChallengeContainerProps = {
  color: string
  elementVisible: boolean
}
export const ChallengeContainer = styled.div<ChallengeContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1170px;
  justify-content: flex-start;

  .container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    max-width: 544px;

    .title {
      position: relative;
      width: 100%;
      z-index: 1;

      .bar {
        position: absolute;
        bottom: 0.7rem;
        border: 2px solid ${(props) => props.color};
        width: 0;
        left: 0;
        z-index: -1;
        transition: width 0.8s ease-in;

        ${({ elementVisible }) =>
          elementVisible &&
          css`
            width: 100%;
          `}
      }

      @media (max-width: 700px) {
        .bar {
          bottom: -0.2rem;
        }
      }
    }
  }
`
